import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-set-contact-limit',
  templateUrl: './set-contact-limit.component.html',
  styleUrls: ['./set-contact-limit.component.scss'],
})
export class SetContactLimitComponent implements OnInit {
  contactLimit: number;

  inputForm: FormGroup;
  constructor() {}

  ngOnInit(): void {
    this.inputForm.addControl(
      'limit',
      new FormControl(this.contactLimit ?? '', [Validators.required])
    );
  }
}
